import DateFnsUtils from "@date-io/date-fns";
import { DialogActions, Grid, MenuItem, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { getData, put } from "../../../api/apiCaller";
import Dialog from "../../../components/Dialog";
import SelectAutoComplete from "../../../components/SelectAutoComplete";
import TableData from "../../../components/TableData";
import select from "../../../config/select";
import datetimeHelper from "../../../helper/datetime-helper";
import { globalHistory } from "../../../history";
import { mapActionsToProps as agentAction } from "../../../redux/agent";
import { mapActionsToProps as campaignAction } from "../../../redux/campaigns";
import { mapActionsToProps } from "../../../redux/miniCrm/ticket";
import { mapActionsToProps as callLogsAction } from "../../../redux/telesale/call";
import TicketHistoryDetail from "../../agent-dashboard/TicketHistoryDetail";
import SearchBar from "./SearchBar";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  grid: {
    alignItems: "center",
    display: "flex",
    width: "100%",
  },
  input: {
    width: "100%",
  },
  disabled: {
    color: "#000000 !important",
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

function filterCustomers(array, search) {
  if (search) {
    return search
      ? array.filter(
          (item) =>
            (item &&
              item.Name &&
              item.Name.toLowerCase().includes(search.toLowerCase())) ||
            (item &&
              item.code &&
              item.code.toLowerCase().includes(search.toLowerCase())) ||
            (item &&
              item.user &&
              item.user.fullname &&
              item.user.fullname.toLowerCase().includes(search.toLowerCase()))
        )
      : array;
  }
  return array;
}

class Ticket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {},
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      showpassword: false,
      modalAction: false,
      ticket: {},
      ticketType: "",
      lead: {},
      servicesC: [],
      postTicket: {
        idPostOffice: "",
        postOfficeName: "",
        postalCode: "",
        province: "",
        otherPhone: "",
        otherNote: "",
        idHandlePeople: "",
        handlePeople: "",
      },
      createdAt: "",
      accountName: "",
      Owner_Name: "",
      loadingBtn: false,
      idTicketCurrent: "",
      source: "",
      listAgents: [],
      selectedAgent: "",
      selectedPeopleHandling: "",
      filterValue: {},
      dataTicketExports: [],
    };
  }
  componentDidMount() {
    // this.itemInit();
    this.history = globalHistory();
    this.props.getTicketType();
    this.props.getListCampaignsGroup();
    this.props.getServices();
    this.props.findPos("");
    this.props.findLead("");
    this.props.findPostOffice("", 9999999999);
    this.props.findHandlePeople("", 9999999999);
    this.props.getListAgent(null, null, null, null, null, { query: "all" });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (prevProps.services || []).length !== (prevState.servicesC || []).length
    ) {
      this.setState({
        servicesC: this.props.services,
      });
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listAgents)) !==
        JSON.parse(JSON.stringify(_.values(props.listAgents))) &&
      !state.listAgents
    ) {
      return {
        listAgents: _.values(props.listAgents),
      };
    }
    return null;
  }

  listCollumns = [
    // {
    //   customValue: (item) => item.attributes?.packageCode || "",
    //   label: "Mã bưu gửi",
    // },
    // {
    //   id: "refId",
    //   disablePadding: false,
    //   label: "Mã ticket",
    // },
    {
      id: "address",
      disablePadding: false,
      label: "Bưu điện tỉnh/thành phố",
      customValue: (item) => item.address || "_",
    },

    {
      id: "districtname",
      disablePadding: false,
      label: "Bưu điện huyện",
      customValue: (item) => item.districtname || "_",
    },
    {
      id: "name",
      disablePadding: false,
      label: "Bưu cục",
      customValue: (item) => item.name || "_",
    },
    {
      id: "phone",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại",
    },
    // {
    //   customValue: (item) => item.statusText || "",
    //   disablePadding: false,
    //   label: "Trạng thái ticket",
    // },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian tạo",
    },
    {
      id: "actionEditAndViewTicket",
      numeric: true,
      disablePadding: false,
      label: "Hành động",
    },
  ];

  itemInit() {
    const { filters } = this.state;
    this.props.getReportTicket(filters.order, filters.pageSize, filters.page, {
      ...filters.where,
    });
    this.props.countReportTicket({
      ...filters.where,
    });
  }

  handleSearchSubmit = async (values) => {
    const filters = await this.loadQueryFilter(values);

    this.setState(
      {
        filters,
        filterValue: values,
      },
      () => this.itemInit()
    );
  };

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalView = (item) => {
    let data = [];
    this.state.item = item;
    this.setState({ modalAction: true });
    if (item) {
      if (item._id) {
        for (const key in item.attributes) {
          if (item.attributes.hasOwnProperty(key)) {
            const element = item.attributes[key];
            select.menu_search.filter((i) => {
              if (i.name !== key) return i;
              // if (i.name == 'Package__c') {
              //     if (this.props.package){
              //         console.log(this.props.package)
              //     }
              // }
              return data.push({
                name: i.label,
                id: i.name,
                value: element,
              });
            });
          }
        }
        this.setState({ ticket: { ...item, data } });
      }
    }
  };

  openModalEdit = (item) => {
    const { agentStatus } = this.props;
    this.setState(
      {
        openDialogTicket: true,
        ticketType: item.ticketType ? item.ticketType.id : "",
        createdAt: item.createdAt,
        lead: item.customFields.lead ? item.customFields.lead : {},
        Employee_Name:
          agentStatus &&
          agentStatus.attributes &&
          agentStatus.attributes.Employee &&
          agentStatus.attributes.Employee.name
            ? agentStatus.attributes.Employee.name
            : "",
        ticket: {
          ...item.attributes,
        },
        postTicket: item.customFields.postTicket
          ? JSON.parse(JSON.stringify(item.customFields.postTicket))
          : null,
        idTicketCurrent: item.id,
        source: item.source,
      },
      async () => {
        const info = await getData("/mini-crm/contact/get-contact-by-phone", {
          phone: this.state.ticket.SuppliedPhone,
        });
        this.setState({
          accountName:
            info.data && info.data.accountName ? info.data.accountName : "",
        });
      }
    );
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const filters = { ...this.state.filters };
    filters.page = page * filters.pageSize;
    this.setState({ filters }, () => this.itemInit());
  };

  handleChangeRowsPerPage = (e) => {
    const filters = { ...this.state.filters };
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => this.itemInit()
    );
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD HH:mm:ss");
    this.setState({ to });
  };

  handleSelectTicket = (name) => {
    return (e) => {
      this.setState(
        {
          [name]: e.target.value,
        },
        () => {
          if (this.props.ticketType !== undefined) {
            const ticket = JSON.parse(
              JSON.stringify(this.props.ticketType)
            ).filter((item) => item.id === e.target.value);
            if (ticket) {
              this.setState({
                idTicket: ticket[0].id,
                nameTicket: ticket[0].name,
              });
            }
          }
          // this.setState({ // VNP-56
          //     ticket: {}
          // })
        }
      );
    };
  };

  handleChangeLead = (e) => {
    const name = e.target.name;
    const { lead } = this.state;
    lead[name] = e.target.value;
    this.setState({
      lead,
    });
  };

  handleSearchService = (text) => {
    const { services } = this.props;
    this.setState({
      servicesC: filterCustomers(services, text),
    });
  };

  handleSearchPosOffice = (text) => {
    const { findPos } = this.props;
    findPos(text, 10);
  };

  handleSearchLeadOffice = (text) => {
    const { findLead } = this.props;
    findLead(text, 10);
  };

  handleSearchHandlePeople = (text) => {
    const { findHandlePeople } = this.props;
    findHandlePeople(text, 3);
  };

  handleSearchPostTicket = (text) => {
    const { findPostOffice } = this.props;
    findPostOffice(text, 10);
  };

  onChangeUserLead = (e) => {
    const { lead } = this.state;
    if (e) {
      lead["pos"] = e.id;
      this.setState({
        lead,
        Pos_Name: e.label,
      });
    } else {
      lead["pos"] = "";
      this.setState({
        lead,
        Pos_Name: "",
      });
    }
  };

  handleChangeTicket = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const { ticket } = this.state;
    ticket[name] = e.target.value ? e.target.value : "";
    // let tinh = []
    // let ward = []

    this.setState(
      {
        ticket,
      },
      async () => {
        if (name === "SuppliedPhone") {
          const info = await getData("/mini-crm/contact/get-contact-by-phone", {
            phone: this.state.ticket.SuppliedPhone,
          });

          const { agentStatus } = this.props;
          this.setState({
            ticket: {
              ...this.state.ticket,
              // SuppliedPhone: info.data && info.data.phone ? info.data.phone : '',
              SuppliedName: info.data && info.data.name ? info.data.name : "",
            },
            Employee_Name:
              agentStatus &&
              agentStatus.attributes &&
              agentStatus.attributes.Employee &&
              agentStatus.attributes.Employee.name
                ? agentStatus.attributes.Employee.name
                : "",
            accountName:
              info.data && info.data.accountName ? info.data.accountName : "",
          });
        }
      }
    );
  };

  handleCreateTicket = async (e, type) => {
    this.setState({ loadingBtn: true });
    // e.preventDefault();
    const {
      idTicketPhone,
      idTicket,
      idTicketCurrent,
      ticket,
      ticketType,
      logInboundOutbound,
    } = this.state;
    const { initStatus, agentStatus } = this.props;
    const { infoCustomer, infoCustomerWithoutSocket } = this.props;
    const name = JSON.parse(JSON.stringify(this.props.ticketType)).filter(
      (item) => item.id === ticketType
    );
    if (!ticket.SuppliedName) {
      ticket.SuppliedName = infoCustomer.name;
    }

    let newTicket = {};
    if (ticketType) {
      if (
        ticketType === "co-cong" ||
        ticketType === "luong-huu" ||
        ticketType === "bao-hiem-xa-hoi"
      ) {
        newTicket["type"] = name.length > 0 ? name[0].name : "";
      } else {
        newTicket["Type"] = name.length > 0 ? name[0].name : "";
      }
    }
    if (
      initStatus &&
      initStatus.agentStatus &&
      initStatus.agentStatus.attributes &&
      initStatus.agentStatus.attributes.Employee &&
      initStatus.agentStatus.attributes.Employee.id
    ) {
      newTicket["Employee__c"] = initStatus.agentStatus.attributes.Employee.id;
    }

    let _ticket = {};
    let _lead = {};
    _ticket = {
      ...newTicket,
      ...ticket,
      AccountId: infoCustomer.accountId ? infoCustomer.accountId : "",
    };
    _lead = {
      lead: {
        isLead: true,
        ...this.state.lead,
      },
      Employee_Name:
        agentStatus.attributes &&
        agentStatus.attributes.Employee &&
        agentStatus.attributes.Employee.name
          ? agentStatus.attributes.Employee.name
          : "",
      Product_Name: this.state.Product_name,
      Pos_Name: this.state.Pos_Name,
      Owner_Name: this.state.Owner_Name,
      accountName: infoCustomer.accountName ? infoCustomer.accountName : "",
    };

    if (this.state.ticketType === "5f145e337d243d55d4614b8e") {
      // Đối với Hỗ trợ điểm bán thì thêm postTicket vào customFields
      _lead["postTicket"] = this.state.postTicket;
    }

    let _atr = { attributes: _ticket };

    if (this.state.lead.pos) {
      _atr = { ..._atr, customFields: _lead };
      if (idTicketCurrent) {
        // this.props.updateTicket(idTicketCurrent, idTicket, _atr,ticket ? ticket.SuppliedPhone : '', 'inbound', "", "", "");
        const updateTicket = await put(`/mini-crm/ticket/${idTicketCurrent}`, {
          type: idTicket,
          ..._atr,
          phone: ticket ? ticket.SuppliedPhone : "",
          source: this.state.source,
          interactivelogId: "",
          refId: "",
        });
        if (
          updateTicket &&
          updateTicket.status &&
          updateTicket.status === 200
        ) {
          this.props.updateListTicket(updateTicket.data);
          this.props.updateTicketSuccessNoti();
          this.clearStateTicket();
        } else {
          this.props.updateTicketErrorNoti();
          this.setState({
            loadingBtn: false,
          });
        }
      }
      this.props.clearProps();
    } else {
      _atr = {
        ..._atr,
        customFields: {
          Employee_Name:
            agentStatus.attributes &&
            agentStatus.attributes.Employee &&
            agentStatus.attributes.Employee.name
              ? agentStatus.attributes.Employee.name
              : "",
          Product_Name: this.state.Product_name,
          Pos_Name: this.state.Pos_Name,
          Owner_Name: this.state.Owner_Name,
          accountName: infoCustomer.accountName ? infoCustomer.accountName : "",
        },
      };

      if (this.state.ticketType === "5f145e337d243d55d4614b8e") {
        // Đối với Hỗ trợ điểm bán thì thêm postTicket vào customFields
        _atr.customFields["postTicket"] = this.state.postTicket;
      }

      if (idTicketCurrent) {
        // this.props.updateTicket(idTicketCurrent, idTicket, _atr,ticket ? ticket.SuppliedPhone : '', 'inbound', "", "", "");
        const updateTicket = await put(`/mini-crm/ticket/${idTicketCurrent}`, {
          type: idTicket,
          ..._atr,
          phone: ticket ? ticket.SuppliedPhone : "",
          source: this.state.source,
          interactivelogId: "",
          refId: "",
        });

        if (
          updateTicket &&
          updateTicket.status &&
          updateTicket.status === 200
        ) {
          this.props.updateListTicket(updateTicket.data);
          this.props.updateTicketSuccessNoti();
          this.clearStateTicket();
        } else {
          this.props.updateTicketErrorNoti();
          this.setState({
            loadingBtn: false,
          });
        }
      }
      this.props.clearProps();
    }
  };

  clearStateTicket = () => {
    this.setState({
      openDialogTicket: false,
      ticket: {},
      optionTicket: false,
      ticketType: "",
      lead: {},
      accountName: "",
      code: "",
      Product_Name: "",
      Pos_Name: "",
      Owner_Name: "",
      SuppliedPhone: "",
      Employee_Name: "",
      SuppliedName: "",
      idTicketCurrent: "",
      loadingBtn: false,
      source: "",
      postTicket: {
        idPostOffice: "",
        postOfficeName: "",
        postalCode: "",
        province: "",
        otherPhone: "",
        otherNote: "",
        idHandlePeople: "",
        handlePeople: "",
      },
    });
  };

  loadQueryFilter = async (values) => {
    const filters = { ...this.state.filters };
    filters.where = {
      ...(values.source && { source: values.source }),
      ...(values.ticketType && { type: values.ticketType }),
      // ...(values.refId && { refId: { like: values.refId } }),
      // ...(values.packageCode && {
      //   "attributes.packageCode": { like: values.packageCode },
      // }),
      ...(values.agent && {
        "createdBy.userId": values.agent.userId,
      }),
      // ...(values.status && {
      //   statusText: { like: values.status },
      // }),
      ...(values.phoneNumber && { phone: values.phoneNumber }),
      ...(values.from && {
        from: datetimeHelper.toFormat(values.from, "YYYY-MM-DD startDay"),
      }),
      ...(values.to && {
        to: datetimeHelper.toFormat(values.to, "YYYY-MM-DD endDay"),
      }),
      ...(values.subOrg && {
        subOrg: values.subOrg,
      }),
      ...(values.cityCode && { cityCode: values.cityCode }),
      ...(values.districtCode && {
        districtCode: values.districtCode,
      }),
    };

    await this.setState({ filters: filters });
    return filters;
  };

  _export;
  export = async (values) => {
    const filters = await this.loadQueryFilter(values);
    await this.callApiReportTicket(filters, values);
    this._export.save();
  };

  async callApiReportTicket(filters, filterValue) {
    const params = {
      ...(filterValue.cityCode && { cityCode: filterValue.cityCode }),
      ...(filterValue.districtCode && {
        districtCode: filterValue.districtCode,
      }),
    };
    let queryArray = [];
    Object.keys(params).map((key) => {
      queryArray.push(`${key}=${params[key]}`);
    });
    this.setState({ isLoading: true });
    const { data } = await getData(`/mini-crm/ticket?${queryArray.join("&")}`, {
      filter: { order: filters.order, where: filters.where },
    });
    this.setState({ isLoading: false });
    this.setState({ dataTicketExports: data });
  }

  render() {
    const {
      classes,
      tickets,
      count,
      campaignsGroup,
      services,
      posOffice,
      isLoading,
      lead,
      leadLoading,
    } = this.props;

    const { id, name, filters, item, dataTicketExports } = this.state;
    const listCampaignResult =
      typeof campaignsGroup === "object"
        ? Object.keys(campaignsGroup).map((key) => campaignsGroup[key])
        : campaignsGroup;

    dataTicketExports.map((item) => {
      item.packageCode = item.attributes?.packageCode || "";
    });
    return (
      <React.Fragment>
        <SearchBar onSubmit={this.handleSearchSubmit} onExport={this.export} />
        <ExcelExport
          data={dataTicketExports}
          ref={(exporter) => (this._export = exporter)}
          fileName="Báo cáo ticket.xlsx">
          {/* <ExcelExportColumn
            field="packageCode"
            title="Mã bưu gửi"
            locked={true}
            width={100}
          /> */}
          {/* <ExcelExportColumn
            field="refId"
            title="Mã ticket"
            locked={true}
            width={100}
          /> */}
          <ExcelExportColumn
            field="cityname"
            title="Bưu điện tỉnh/thành phố"
            width={100}
          />
          <ExcelExportColumn
            field="districtName"
            title="Bưu điện huyện"
            width={100}
          />
          <ExcelExportColumn field="proviceName" title="Bưu cục" width={100} />
          <ExcelExportColumn field="phone" title="Số điện thoại" width={100} />
          {/* <ExcelExportColumn
            field="statusText"
            title="Trạng thái ticket"
            width={100}
          /> */}
          <ExcelExportColumn
            field="createdAt"
            title="Thời gian tạo"
            width={100}
          />
        </ExcelExport>
        <TableData
          {...this.props}
          nameTable="Danh sách ticket"
          items={Array.isArray(tickets) && tickets.length > 0 ? tickets : []}
          rowsPerPage={filters.pageSize}
          count={this.props.count ? this.props.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={false}
          handleView={this.openModalView}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
        <Dialog
          open={this.state.openDialogTicket}
          onClose={() => {
            this.setState({
              openDialogTicket: false,
            });
          }}
          title="Sửa ticket"
          maxWidth="xl"
          input={
            <ValidatorForm
              onSubmit={(e) => this.handleCreateTicket(e, this.state.type)}
              ref={(ref) => {
                this.formSubmit = ref;
              }}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container spacing={16}>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <Typography
                      style={{
                        backgroundColor: "#d3d4d9",
                        padding: "5px 15px",
                        fontSize: 18,
                      }}>
                      Thông tin ticket
                    </Typography>
                    <Grid container={true} spacing={16}>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="dense"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Loại yêu cầu"
                          variant="outlined"
                          className={classes.input}
                          autoFocus={true}
                          onChange={this.handleSelectTicket("ticketType")}
                          value={this.state.ticketType}
                          name="ticketType"
                          validators={["required"]}
                          required
                          errorMessages={[`Không được để trống`]}
                          size="small">
                          {this.props.ticketType !== undefined ? (
                            this.props.ticketType.map((item, key) => {
                              if (
                                item.refId !== "hoa-sao" &&
                                item.refId !== "luong-huu" &&
                                item.refId !== "co-cong" &&
                                item.refId !== "bao-hiem-xa-hoi" &&
                                item.refId !== "outbound"
                              ) {
                                return (
                                  <MenuItem key={key} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              }
                            })
                          ) : (
                            <React.Fragment />
                          )}
                        </SelectValidator>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <SelectValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Trạng thái"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangeTicket}
                          value={
                            this.state.ticket !== {} && this.state.ticket.Status
                              ? this.state.ticket.Status
                              : ""
                          }
                          name="Status"
                          validators={["required"]}
                          required
                          errorMessages={[`Không được để trống`]}>
                          <MenuItem key="Mới tạo" value="Mới tạo">
                            Mới tạo
                          </MenuItem>
                          <MenuItem key="Đã tiếp nhận" value="Đã tiếp nhận">
                            Đã tiếp nhận
                          </MenuItem>
                          <MenuItem key="Đang xử lí" value="Đang xử lí">
                            Đang xử lí
                          </MenuItem>
                          <MenuItem key="Đã có kết quả" value="Đã có kết quả">
                            Đã có kết quả
                          </MenuItem>
                          <MenuItem key="Đã hoàn thành" value="Đã hoàn thành">
                            Đã hoàn thành
                          </MenuItem>
                          <MenuItem key="Hủy" value="Hủy">
                            Hủy
                          </MenuItem>
                          <MenuItem key="Mở lại" value="Mở lại">
                            Mở lại
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <SelectValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Mức độ ưu tiên"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangeTicket}
                          value={
                            this.state.ticket !== {} &&
                            this.state.ticket.Priority
                              ? this.state.ticket.Priority
                              : ""
                          }
                          name="Priority"
                          validators={["required"]}
                          required
                          errorMessages={[`Không được để trống`]}>
                          <MenuItem key="Cao" value="Cao">
                            Cao
                          </MenuItem>
                          <MenuItem key="Trung bình" value="Trung bình">
                            Trung bình
                          </MenuItem>
                          <MenuItem key="Thấp" value="Thấp">
                            Thấp
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <InlineDatePicker
                          size="small"
                          margin="dense"
                          label="Ngày tiếp nhận"
                          variant="outlined"
                          className={classes.input}
                          value={this.state.createdAt}
                          format="dd/MM/yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="Nga_y_ti_p_nh_n__c"
                          keyboard
                          disabled
                          ampm={false}
                          mask={[
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            "/",
                            /\d/,
                            /\d/,
                            /\d/,
                            /\d/,
                          ]}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <Typography
                      style={{
                        backgroundColor: "#d3d4d9",
                        padding: "5px 15px",
                        fontSize: 18,
                      }}>
                      Thông tin liên hệ
                    </Typography>
                    <Grid container={true} spacing={16}>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Số điện thoại liên hệ"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangeTicket}
                          name="SuppliedPhone"
                          value={
                            this.state.ticket && this.state.ticket.SuppliedPhone
                              ? this.state.ticket.SuppliedPhone
                              : ""
                          }
                          validators={["required"]}
                          required
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Nhân viên tiếp nhận và xử lý"
                          variant="outlined"
                          className={classes.input}
                          style={{ backgroundColor: "wheat" }}
                          disabled
                          value={
                            this.state.ticket && this.state.Employee_Name
                              ? this.state.Employee_Name
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Tên người liên hệ (Contact)"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangeTicket}
                          name="SuppliedName"
                          value={
                            this.state.ticket &&
                            this.state.ticket.SuppliedName &&
                            this.state.ticket.SuppliedName !== "undefined"
                              ? this.state.ticket.SuppliedName
                              : ""
                          }
                          validators={["required"]}
                          required
                          errorMessages={[`Không được để trống`]}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Tên khách hàng (Account)"
                          variant="outlined"
                          className={classes.input}
                          value={
                            this.state.ticket && this.state.accountName
                              ? this.state.accountName
                              : ""
                          }
                          style={{ backgroundColor: "wheat" }}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Email người liên hệ"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangeLead}
                          name="leadEmail"
                          type="email"
                          validators={[
                            'matchRegexp:^(([^<>()\\[\\]\\.,;:\\s@\\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\\"]+)*)|(\\".+\\"))@(([^<>()[\\]\\.,;:\\s@\\"]+\\.)+[^<>()[\\]\\.,;:\\s@\\"]{2,})$',
                          ]}
                          errorMessages={["Email không đúng định dạng"]}
                          value={
                            this.state.lead !== {} &&
                            this.state.lead.leadEmail !== {} &&
                            this.state.lead.leadEmail
                              ? this.state.lead.leadEmail
                              : ""
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Typography
                  style={{
                    backgroundColor: "#d3d4d9",
                    padding: "5px 15px",
                    fontSize: 18,
                  }}>
                  Thông tin tiếp nhận yêu cầu
                </Typography>
                <Grid container={true} spacing={16}>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <TextValidator
                      size="small"
                      id="outlined-full-width"
                      margin="dense"
                      label="Chủ đề"
                      variant="outlined"
                      className={classes.input}
                      onChange={this.handleChangeTicket}
                      name="Subject"
                      value={
                        this.state.ticket !== {} && this.state.ticket.Subject
                          ? this.state.ticket.Subject
                          : ""
                      }
                      // validators={["required"]}
                      // required
                      // errorMessages={[`Không được để trống`]}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={6}
                    lg={6}
                    style={{ paddingTop: "16px" }}>
                    <SelectAutoComplete
                      label={"Dịch vụ sử dụng"}
                      className={classes.input}
                      data={
                        this.state.servicesC.length > 0 &&
                        this.state.servicesC.map((item) => {
                          return {
                            id: item.Id,
                            label: item.Name,
                          };
                        })
                      }
                      value={
                        this.state.ticket !== {} && this.state.ticket.Service__c
                          ? this.state.ticket.Service__c
                          : ""
                      }
                      onSearch={debounce(
                        (text) => this.handleSearchService(text),
                        300
                      )}
                      required={true}
                      onChange={(val) => {
                        const { ticket } = this.state;
                        ticket["Service__c"] = val && val.id ? val.id : "";
                        this.setState({
                          ticket,
                          Product_name:
                            val && val.id
                              ? services.filter((v) => v.Id === val.id)[0].Name
                              : "",
                        });
                      }}
                      onClear={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <TextValidator
                      size="small"
                      id="outlined-full-width"
                      margin="dense"
                      label="Mô tả yêu cầu"
                      variant="outlined"
                      className={classes.input}
                      onChange={this.handleChangeTicket}
                      name="Description"
                      value={
                        this.state.ticket !== {} &&
                        this.state.ticket.Description
                          ? this.state.ticket.Description
                          : ""
                      }
                      multiline
                      rows={2}
                      validators={["required"]}
                      required
                      errorMessages={[`Không được để trống`]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <TextValidator
                      size="small"
                      id="outlined-full-width"
                      margin="dense"
                      label="Mã giao dịch"
                      variant="outlined"
                      className={classes.input}
                      onChange={this.handleChangeTicket}
                      name="Package_text__c"
                      value={
                        this.state.ticket !== {} &&
                        this.state.ticket.Package_text__c
                          ? this.state.ticket.Package_text__c
                          : ""
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={16}>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <Typography
                      style={{
                        backgroundColor: "#d3d4d9",
                        padding: "5px 15px",
                        marginBottom: "5px",
                        fontSize: 18,
                      }}>
                      Chuyển ticket
                    </Typography>
                    <SelectAutoComplete
                      label={"Đơn vị nhận ticket"}
                      // data={posOffice && posOffice.length > 0 ? posOffice.map(val => {
                      //     return i{
                      //         id: val.name,
                      //         label: val.unitName + ' - ' + val.name,
                      //         name: val.name
                      //     }
                      // }) : []}
                      data={
                        posOffice &&
                        posOffice.length > 0 &&
                        posOffice.map((val) => {
                          return {
                            id: val.id,
                            label: val.name + " - " + val.id,
                          };
                        })
                      }
                      value={
                        this.state.ticket !== {} && this.state.ticket.OwnerId
                          ? this.state.ticket.OwnerId
                          : ""
                      }
                      onSearch={debounce(this.handleSearchPosOffice, 300)}
                      onChange={(item) => {
                        if (item) {
                          // const name = "Unit__r.Name"; 30/05/2020 12h30
                          const name = "OwnerId";
                          const { ticket } = this.state;
                          ticket[name] = item.id;
                          this.setState({
                            ticket,
                            // Owner_Name: item.label,
                            Owner_Name: item.label,
                          });
                        }
                      }}
                      loading={isLoading}
                      onClear={true}
                      // loading={leadLoading}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                    <Typography
                      style={{
                        backgroundColor: "#d3d4d9",
                        padding: "5px 15px",
                        marginBottom: "5px",
                        fontSize: 18,
                      }}>
                      Chuyển khách hàng tiềm năng
                    </Typography>
                    <SelectAutoComplete
                      label={"Đơn vị nhận khách hàng tiềm năng"}
                      data={
                        lead &&
                        lead.length > 0 &&
                        lead.map((val) => {
                          return {
                            id: val.id,
                            label: val.name + " - " + val.id,
                          };
                        })
                      }
                      // required={this.state.showRequire}
                      required={false}
                      value={
                        this.state.lead &&
                        this.state.lead !== {} &&
                        this.state.lead.pos
                          ? this.state.lead.pos
                          : ""
                      }
                      onSearch={debounce(this.handleSearchLeadOffice, 300)}
                      onChange={this.onChangeUserLead}
                      onClear={true}
                      loading={leadLoading}
                    />
                  </Grid>
                </Grid>
                {this.state.ticketType === "5f145e337d243d55d4614b8e" && (
                  <>
                    <Typography
                      style={{
                        backgroundColor: "#d3d4d9",
                        padding: "5px 15px",
                        fontSize: 18,
                        marginTop: "8px",
                      }}>
                      Thông tin hỗ trợ điểm bán
                    </Typography>
                    <Grid container={true} spacing={16}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={6}
                        lg={6}
                        style={{ paddingTop: "16px" }}>
                        <SelectAutoComplete
                          label={"Bưu cục - Điểm văn hóa xã"}
                          className={classes.input}
                          data={
                            this.props.postOffice.length > 0 &&
                            this.props.postOffice.map((item) => {
                              return {
                                id: item.code,
                                label: item.post,
                                ditrict: item.ditrict,
                                city: item.city,
                              };
                            })
                          }
                          value={
                            this.state.postTicket &&
                            this.state.postTicket.idPostOffice
                              ? this.state.postTicket.idPostOffice
                              : ""
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchPostTicket(text),
                            300
                          )}
                          required={true}
                          loading={this.props.postOfficeLoading}
                          onChange={(val) => {
                            const { postTicket } = this.state;
                            postTicket["idPostOffice"] =
                              val && val.id ? val.id : "";
                            postTicket["postOfficeName"] =
                              val && val.label ? val.label : "";
                            postTicket["postalCode"] =
                              val && val.id ? val.id : "";
                            postTicket["province"] =
                              val && val.city ? val.city : "";
                            this.setState({
                              postTicket,
                            });
                          }}
                          onClear={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Mã bưu cục"
                          variant="outlined"
                          className={classes.input}
                          value={
                            this.state.postTicket &&
                            this.state.postTicket.postalCode
                              ? this.state.postTicket.postalCode
                              : ""
                          }
                          style={{ backgroundColor: "wheat" }}
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        {/*<TextValidator*/}
                        {/*    size="small"*/}
                        {/*    id="outlined-full-width"*/}
                        {/*    margin="dense"*/}
                        {/*    label="Quận huyện"*/}
                        {/*    variant="outlined"*/}
                        {/*    className={classes.input}*/}
                        {/*    value={this.state.postTicket && this.state.postTicket.province ? this.state.postTicket.province : ''}*/}
                        {/*    style={{backgroundColor: 'wheat'}}*/}
                        {/*    disabled*/}
                        {/*/>*/}
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Tỉnh thành"
                          variant="outlined"
                          className={classes.input}
                          value={
                            this.state.postTicket &&
                            this.state.postTicket.province
                              ? this.state.postTicket.province
                              : ""
                          }
                          style={{ backgroundColor: "wheat" }}
                          disabled
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={6}
                        lg={6}
                        style={{ marginTop: "8px" }}>
                        <SelectAutoComplete
                          label={"Người xử lý"}
                          className={classes.input}
                          data={
                            this.props.handlePeople.length > 0 &&
                            this.props.handlePeople.map((item) => {
                              return {
                                id: item.id,
                                label: item.username,
                              };
                            })
                          }
                          value={
                            this.state.postTicket &&
                            this.state.postTicket.idHandlePeople
                              ? this.state.postTicket.idHandlePeople
                              : ""
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchHandlePeople(text),
                            300
                          )}
                          required={false}
                          loading={this.props.handlePeopleLoading}
                          onChange={(val) => {
                            const { postTicket } = this.state;
                            postTicket["idHandlePeople"] =
                              val && val.id ? val.id : "";
                            postTicket["handlePeople"] =
                              val && val.label ? val.label : "";
                            this.setState({
                              postTicket,
                            });
                          }}
                          onClear={true}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Số điện thoại liên hệ khác nếu có"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangePostOffice}
                          name="otherPhone"
                          value={
                            this.state.postTicket &&
                            this.state.postTicket.otherPhone
                              ? this.state.postTicket.otherPhone
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} xl={6} lg={6}>
                        <TextValidator
                          size="small"
                          id="outlined-full-width"
                          margin="dense"
                          label="Ghi chú khác nếu có"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangePostOffice}
                          name="otherNote"
                          value={
                            this.state.postTicket &&
                            this.state.postTicket.otherNote
                              ? this.state.postTicket.otherNote
                              : ""
                          }
                          multiline
                          rows={2}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </MuiPickersUtilsProvider>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.setState({
                      openDialogTicket: false,
                      optionTicket: false,
                    });
                  }}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  type="submit"
                  disabled={this.state.loadingBtn}>
                  {this.state.loadingBtn && <CircularProgress />}
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog
          open={this.state.modalAction}
          title={`Xem thông tin ticket ${
            this.state.ticket?.attributes?.packageCode || ""
          }`}
          maxWidth="xl"
          input={<TicketHistoryDetail ticketData={this.state.ticket} />}
          onClose={this.handleClose}
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

Ticket.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  ...state.ticket,
  ...state.campaign,
  ...state.call,
  agentStatus: state.agent.status,
  listAgents: state.agent.agents,
  loading: state.ticket.loadingTicket,
  count: state.ticket.count,
});

const Campaign = connect(null, campaignAction)(Ticket);
const CallLogs = connect(null, callLogsAction)(Campaign);
const AgentAction = connect(null, agentAction)(CallLogs);

Ticket = connect(mapStateToProps, mapActionsToProps)(AgentAction);

export default withStyles(styles)(Ticket);
